import React from 'react';
import { useContext } from 'react';
import Loader from '../common/Loader';
import { getConfiguration } from '../data/utils';
import { useFetch } from '../data/fetch/useFetch';
import { buildMenuData } from '../data/data';

export const PrematchDataContext = React.createContext(null);

export function usePrematchData() {
    return useContext(PrematchDataContext);
}

function PrematchDataFetcher(props) {
    const conf = getConfiguration();

    const [isLoading, isError, data] = useFetch(conf.api.getMenuPrematch, null, (data) => {
        const parsedData = buildMenuData(data);
        if (parsedData) {
            parsedData.nel = data.nel;
            parsedData.nep = data.nep;
        }
        return parsedData;
    });

    if (isLoading) {
        return null;
    }
    if (isError) {
        return <Loader error={isError} />;
    }

    return (
        <PrematchDataContext.Provider value={data}>
            {props.children}
        </PrematchDataContext.Provider>
    );
}

export default PrematchDataFetcher;